import {Injectable, OnDestroy, signal} from '@angular/core';
import {Subscription} from 'rxjs';
import {DfpStateData} from '../types/DfpStateData';
import {ToolsService} from './tools.service';
import {IsCustomerDfpEnum} from '../enums/AdEnums';
import {NavigationEnd, Router, UrlSegment, UrlTree} from '@angular/router';
import {RoutesEnums} from '../enums/RoutesEnums';
import {filter} from 'rxjs/operators';

@Injectable()
export class AdsStateService implements OnDestroy {
  public state = signal<DfpStateData>(this.getDefaultDfpState());
  private routeListener: Subscription;
  private routesWithTheirOwnImplementation: string[] = [
    RoutesEnums.CAREPROVIDER,
    RoutesEnums.CARESERVICE,
    RoutesEnums.SEARCH,
    RoutesEnums.FOR_CAREPROVIDERS,
  ];
  private readonly HOME_MODULE_NAME = 'home';

  constructor(
    private tools: ToolsService,
    private router: Router,
  ) {
    this.routeListener = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.handleRouteChange());
  }

  public ngOnDestroy(): void {
    this.routeListener.unsubscribe();
  }

  public updateAdsStateProperty(propertyName: string, propertyValue: string | number | boolean): void {
    let state: DfpStateData = this.tools.clone(this.state());
    if (state[propertyName] !== propertyValue) {
      state[propertyName] = propertyValue;
      this.updateAdsState(state);
    }
  }

  public updateAdsState(newState: DfpStateData): void {
    if (!this.tools.isEqual(this.state(), newState)) {
      this.state.set(newState);
    }
  }

  public resetState(pageModule?: string): void {
    const state = this.getDefaultDfpState();
    if (!this.tools.isNil(pageModule)) {
      state.pageModule = pageModule;
    }
    this.updateAdsState(state);
  }

  public getDefaultDfpState(): DfpStateData {
    return {
      careproviderUnitTypeId: null,
      careServiceTypeId: null,
      symptomId: null,
      placeId: null,
      isCustomer: IsCustomerDfpEnum.NA,
      pageModule: null,
    };
  }

  private handleRouteChange(): void {
    const url = this.router.url;
    const urlTree: UrlTree = this.router.parseUrl(url);
    const segments: UrlSegment[] =
      urlTree && urlTree.root.children['primary'] && urlTree.root.children['primary'].segments
        ? urlTree.root.children['primary'].segments
        : [];
    const pageModule: string = segments && segments.length > 0 ? segments[0].path : this.HOME_MODULE_NAME;
    if (this.tools.isNil(this.routesWithTheirOwnImplementation[pageModule])) {
      this.resetState(pageModule);
    } else {
      const state = this.state();
      state.pageModule = pageModule;
      this.updateAdsState(state);
    }
  }
}
